let InscriptionType = {
  CPF: { id: 1, name: 'CPF', mask: '999.999.999-99'},
  CNPJ: { id: 2, name: 'CNPJ', mask: 'SS.SSS.SSS/SSSS-99'},
};

export default InscriptionType;
export const inscriptionTypes = Object.keys(InscriptionType).map(key => InscriptionType[key]);



// WEBPACK FOOTER //
// ./src/enums/InscriptionType.js